import React, { useEffect, useRef } from 'react';
import { usePage } from '@inertiajs/react';

const GoogleMap = ({ lat, lng }) => {
    const mapRef = useRef(null);
    const { config } = usePage().props;

    useEffect(() => {
        const loadGoogleMaps = async () => {
            if (!window.google) {
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=${config.googleMaps.apiKey}&channel=${config.googleMaps.channelId}&libraries=marker`;
                script.async = true;

                await new Promise((resolve) => {
                    script.onload = resolve;
                    document.body.appendChild(script);
                });
            }

            const latLng = { lat, lng };
            const map = new google.maps.Map(mapRef.current, {
                zoom: 15,
                center: latLng,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                disableDefaultUI: true,
                scrollwheel: false,
                clickableIcons: false,
                draggable: false,
                // TODO: Add mapId
                mapId: "DEMO_MAP_ID",
            });

            new google.maps.marker.AdvancedMarkerElement({
                map,
                position: latLng,
            });
        };

        loadGoogleMaps();
    }, [lat, lng, config]);

    return <div ref={mapRef} className="p-detail_map" style={{ height: '180px' }} />;
};

export default GoogleMap;
